<template>
    <div>
        <!-- <p class="headline mb-5" v-html="contents[0].Title.split('#').length > 0 ? contents[0].Title.split('#')[1] : ''"></p> -->
        <v-img
        :src="`${$url}/downloadfile/${contents[0].Files[0] ? contents[0].Files[0].ID : ''}`"
        :lazy-src="`${$url}/downloadfile/${contents[0].Files[0] ? contents[0].Files[0].ID : ''}`"
        :width="240"
        class="transparent float-sm-left mr-4 mb-2"
        >
        <template v-slot:placeholder>
            <v-row
            fill-height
            align-center
            justify-center
            ma-0
            >
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
        </template>
        </v-img>
        <span class="mb-5 ql-editor">
        <span v-html="contents[0].Body"></span>
        </span>
    </div>
</template>
<script>
    export default {
        props: ['contents']
    }
</script>